import { Mail, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { CONTACT_EMAIL, NOVA_URL } from "../data/site";

export const Contact = () => {
  return (
    <section id="contact" data-testid="contact-section" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-[28px] border border-zinc-200 bg-white p-10 sm:p-14 lg:p-20 shadow-sm">
            <div className="absolute inset-0 nova-glow pointer-events-none" aria-hidden="true" />
            <div className="absolute -bottom-32 -right-24 w-96 h-96 rounded-full bg-blue-100/70 blur-3xl pointer-events-none" aria-hidden="true" />

            <div className="relative max-w-2xl">
              <span className="text-xs font-bold tracking-[0.2em] uppercase text-blue-600">
                Contact
              </span>
              <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-zinc-900">
                Let&apos;s build something enterprise-grade
              </h2>
              <p className="mt-5 text-base text-zinc-600 leading-relaxed">
                Whether you&apos;re exploring compliance with Nova or a broader AI initiative,
                we&apos;d love to hear from you. Reach out and a member of our team will get
                back to you.
              </p>

              <div className="mt-10">
                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  data-testid="contact-email-btn"
                  className="group inline-flex items-center gap-3 rounded-2xl border border-zinc-200 bg-white px-6 py-4 hover:border-zinc-300 hover:shadow-md transition-shadow"
                >
                  <span className="grid place-items-center w-10 h-10 rounded-xl bg-blue-50 text-blue-600">
                    <Mail className="w-5 h-5" />
                  </span>
                  <span className="text-left">
                    <span className="block text-xs text-zinc-500">Email us</span>
                    <span className="block text-sm font-medium text-zinc-900">
                      {CONTACT_EMAIL}
                    </span>
                  </span>
                </a>
              </div>

              <div className="mt-10 pt-8 border-t border-zinc-200">
                <a
                  href={NOVA_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-explore-nova-link"
                  className="group inline-flex items-center gap-2 text-sm text-zinc-600 hover:text-zinc-900 transition-colors"
                >
                  Looking for the product? Explore Nova
                  <ArrowUpRight className="w-4 h-4 text-blue-600 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
